/**
 * card-grid.js
 * ────────────────────────────────────────────────────────────────────────────
 * Intercepts add-to-cart form submissions in the Card Grid section (Card 2 —
 * Routine Products). On success, updates the cart drawer via Shopify's
 * sections rendering API, then opens the drawer using the same pattern as
 * the theme's product-form element.
 */

(function () {
  var SECTIONS = [
    { id: 'Cart',              section: 'main-cart',   selector: '.thb-cart-form' },
    { id: 'Cart-Drawer',       section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
  ];

  function getSectionHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el  = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  function openCartDrawer() {
    var cartDrawer = document.getElementById('Cart-Drawer');
    if (cartDrawer) {
      document.body.classList.add('open-cc', 'open-cart');
      cartDrawer.classList.add('active');
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('cart-drawer:open');
      }
    }
  }

  function handleSubmit(evt) {
    evt.preventDefault();
    var form = evt.currentTarget;
    var btn  = form.querySelector('button[type="submit"]');

    if (btn) {
      btn.disabled = true;
      btn.classList.add('loading');
    }

    var formData = new FormData(form);
    formData.append('sections', SECTIONS.map(function (s) { return s.section; }).join(','));
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/javascript'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('[card-grid] Add to cart error:', response.description);
          return;
        }

        // Update cart sections in the DOM
        if (response.sections) {
          SECTIONS.forEach(function (s) {
            var container = document.getElementById(s.id);
            if (!container || !response.sections[s.section]) return;
            var target = container.querySelector(s.selector) || container;
            target.innerHTML = getSectionHTML(response.sections[s.section], s.selector);
          });
        }

        openCartDrawer();

        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: response.items ? response.items[0] : response
          });
        }
      })
      .catch(function (e) {
        console.error('[card-grid] Fetch error:', e);
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('loading');
        }
      });
  }

  document.querySelectorAll('[data-cg-atc]').forEach(function (form) {
    form.addEventListener('submit', handleSubmit);
  });
})();
